exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-message[data-v-bae16014] {\n  max-width: 600px;\n  display: block;\n  margin: 0 auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/views/link/ranking/link.ranking.list.vue?vue&type=style&index=0&id=bae16014&lang=stylus&scoped=true&
// module id = 755
// module chunks = 0